export default Object.freeze({
    INIT: "init",
    AUTO: "auto",
    USER: "user",
});